// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"d21936c3","283":"469a8546","356":"e80d850a","562":"fe2cc159","574":"bc6b0176","700":"35e89be8","712":"9b5632c8","831":"4d493969","848":"1f15eb9e"}[chunkId] + ".chunk.js";
};